<script>
export default {
    name: "ItemUserSend",
    props: {
        message: {
            type: Object,
            required: true,
            default: () => {}
        },
        type: {
            type: Number,
            required: true,
            default: 1
        },
        messageSelectedId: {
            type: Number,
            required: true,
            default: 0
        }
    },
    data() {
        return {

        }
    }
}
</script>

<template>
    <div class="user-item d-flex align-items-center" :class="message?.id === messageSelectedId ? 'message-selected' : ''">
        <img
            :src="type === 1 ? message?.sender?.avatar : message?.receiver?.avatar"
            class="image-avatar" style="border-radius: 9999px; margin-right: 8px"
            @error="e => e.target.src = '/media/default-avatar.png'" alt="avatar"
        />
        <div class="name">
            <h3>{{ type === 1 ? message?.sender?.name : message?.receiver?.name }}</h3>
            <p style="color: #bababa">{{ type === 1 ? message?.sender?.profile?.branch?.name : message?.receiver?.profile?.branch?.name }}</p>
        </div>
    </div>
</template>

<style>
    .message-selected {
        border: 1px solid #6044b8;;
        padding: 5px;
        border-radius: 5px;
    }
    .image-avatar {
        border: 1px solid;
    }
    .user-item {
        display: flex;
        cursor: pointer;
        margin-bottom: 10px;
    }
    .user-item h3, .user-item p  {
        margin: 0;
        padding: 4px 0;
    }
    /* Mobile (điện thoại): < 576px */
    @media (max-width: 575.98px) {
        .user-item h3, .user-item p  {
            margin: 0;
            padding: 4px 0;
            font-size: 12px;
        }
        .image-avatar {
            width: 24px;
            height: 24px;
        }
    }

    /* Tablet: 576px → 991px */
    @media (min-width: 576px) and (max-width: 991.98px) {
        .image-avatar {
            width: 24px;
            height: 24px;
        }
        .user-item h3, .user-item p  {
            margin: 0;
            padding: 2px 0;
            font-size: 12px;
        }
    }

    /* PC (Laptop): 992px → 1199px */
    @media (min-width: 992px) and (max-width: 1199.98px) {
        .image-avatar {
            width: 32px;
            height: 32px;
        }
        .user-item h3, .user-item p  {
            margin: 0;
            padding: 2px 0;
            font-size: 16px;
        }
    }

    /* Large PC / Desktop lớn: 1200px → 1399px */
    @media (min-width: 1200px) and (max-width: 1399.98px) {
        .image-avatar {
            width: 64px;
            height: 64px;
        }
        .user-item h3, .user-item p  {
            margin: 0;
            padding: 2px 0;
            font-size: 18px;
        }
    }

    /* Extra Large PC: ≥ 1400px */
    @media (min-width: 1400px) {
        .image-avatar {
            width: 55px;
            height: 55px;
        }
    }
</style>
